// Telemetry recorder: game events → Supabase, direct insert with the
// publishable key. Insert-only by RLS — clients can write, never read.
// Design rules: never landmarks or video, never block gameplay, self-mute
// on trouble, and a sampling dial in levels/today.json ("telemetrySample",
// 0..1) so a viral day can be throttled without a deploy.

const SUPABASE_URL = "https://icmvanpbhyxeqtfyfzyz.supabase.co";
const SUPABASE_KEY = "sb_publishable_yZqzVJYS331NOJ4SOY0A8A_QSmDH3SL";
const ENDPOINT = `${SUPABASE_URL}/rest/v1/events`;
const MAX_EVENTS_PER_SESSION = 300;
const FLUSH_MS = 10000;

const sessionId = Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
const device = /iPhone|iPad|Android/i.test(navigator.userAgent) ? "mobile" : "desktop";

let queue: object[] = [];
let sent = 0;
let failures = 0;
let muted = false;
let sampledIn = true;

function mute(reason: string) {
  muted = true;
  queue = [];
  console.log("[telemetry] muted:", reason);
}

export function track(event: string, data: object = {}, mode: string | null = null) {
  if (muted || !sampledIn) return;
  if (sent + queue.length >= MAX_EVENTS_PER_SESSION) { mute("session cap"); return; }
  queue.push({
    session_id: sessionId,
    build: (window as any).AOTS_BUILD || "unknown",
    device,
    mode,
    event,
    data,
  });
}

async function flush(useBeacon = false) {
  if (muted || queue.length === 0) return;
  const batch = queue;
  queue = [];
  const body = JSON.stringify(batch);
  try {
    if (useBeacon && navigator.sendBeacon) {
      // sendBeacon can't set headers — fall through to keepalive fetch
    }
    const res = await fetch(ENDPOINT, {
      method: "POST",
      keepalive: useBeacon,
      headers: {
        "Content-Type": "application/json",
        apikey: SUPABASE_KEY,
        Authorization: `Bearer ${SUPABASE_KEY}`,
        Prefer: "return=minimal",
      },
      body,
    });
    if (res.ok) { sent += batch.length; failures = 0; }
    else if (++failures >= 3) mute(`HTTP ${res.status} x3`);
  } catch {
    if (++failures >= 3) mute("network x3");
  }
}

export function initTelemetry() {
  // Sampling dial: today.json can throttle collection without a deploy
  fetch("levels/today.json")
    .then((r) => (r.ok ? r.json() : null))
    .then((d) => {
      const rate = d && typeof d.telemetrySample === "number" ? d.telemetrySample : 1;
      sampledIn = Math.random() < rate;
      if (sampledIn) track("session_start", { ua: navigator.userAgent.slice(0, 120) });
    })
    .catch(() => { sampledIn = true; track("session_start", {}); });

  // Unity game events arrive as compact JSON on a window CustomEvent
  window.addEventListener("telemetry", ((e: CustomEvent) => {
    try {
      const j = JSON.parse(e.detail.j);
      const { event, mode, ...rest } = j;
      track(event || "game_event", rest, mode !== undefined ? String(mode) : null);
    } catch { /* malformed — drop */ }
  }) as EventListener);

  setInterval(() => flush(), FLUSH_MS);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") flush(true);
  });
}
